import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select from 'react-select';
import {withLocalize} from 'react-localize-redux';
import 'react-select/dist/react-select.css';
import {loadCategories} from "../../01-actions/adminCategories";
import './style.css';

class CategorySelector extends Component {
    constructor(props) {
        super(props);
        this.state = {selectedOption: props.value || ''};
        this.handleChange = this.handleChange.bind(this);
        props.loadCategories({withProductCount: true});
    }

    handleChange(selectedOption) {
        this.setState({selectedOption});
        this.props.onSelected && this.props.onSelected(selectedOption && selectedOption.value);
    }

    render() {
        const options = this.props.categories && this.props.categories.map((category) => {
            return {
                value: category._id,
                label: category.name[this.props.activeLanguage.code] + ` (${category.count || 0})`
            };
        });
        return (
            <div className="con-category-selector">
                <Select
                    disabled={this.props.disabled}
                    name="form-field-name"
                    value={this.state.selectedOption}
                    onChange={this.handleChange}
                    options={options}
                />
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        categories: store.adminCategories.categories
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({loadCategories}, dispatch);
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(CategorySelector));


// WEBPACK FOOTER //
// ./src/04-containers/CategorySelector/index.js